module.exports = __webpack_public_path__ + "img/germany.97f542f0.svg";